export enum RoleTypeId {
  System = 1,
  Custom = 2,
}
